import type { AppRoute } from "@/lib/routing";

// Owner: C3 (inventory, imports and search). Paths follow spec §9.1.
export const routes: AppRoute[] = [
  {
    path: "/imports",
    lazy: async () => ({ Component: (await import("./pages/ImportsPage")).ImportsPage }),
    handle: {
      title: "Imports",
      keywords: ["csv", "excel", "paste order", "formulair", "molequles", "upload", "undo import"],
    },
  },
  {
    path: "/imports/:id",
    lazy: async () => ({ Component: (await import("./pages/ImportPage")).ImportPage }),
    handle: { title: "Import" },
  },
];
